import {
  login,
  loginNew,
  logout,
  getInfo,
  getInfoNew,
  loginPhone,
  loginByWx,
} from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
// import router, { resetRouter } from '@/router'

const state = {
  token: '',
  name: '',
  account: '',
  noPayProject: [],
  yourProject: [],
  offlineProject: [], // 归档产品
  id: '',
  appImg: '',
  androidImg: '',
  isVocational: null, //是否开通过高职
  // avatar: '',
  // introduction: '',
  // roles: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_ACCOUNT: (state, account) => {
    state.account = account
  },
  SET_NOPAYPROJECT: (state, noPayProject) => {
    state.noPayProject = noPayProject
  },
  SET_YOURPROJECT: (state, yourProject) => {
    state.yourProject = yourProject
  },
  SET_ID: (state, ID) => {
    state.id = ID
  },
  SET_APPIMG: (state, APPIMG) => {
    state.appImg = APPIMG
  },
  SET_ANDROIDIMG: (state, ANDROIDIMG) => {
    state.androidImg = ANDROIDIMG
  },
  SET_OffLineProject: (state, project) => {
    state.offlineProject = project
  },
  SET_ISVOCATIONAL: (state, isVocational) => {
    state.isVocational = isVocational
  },
  // SET_AVATAR: (state, avatar) => {
  //   state.avatar = avatar
  // },
  // SET_ROLES: (state, roles) => {
  //   state.roles = roles
  // }
}

const actions = {
  // 涉及了uid登录 勿改
  login({ commit }, userInfo) {
    // const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login(userInfo)
        .then((response) => {
          const { data } = response
          commit('SET_TOKEN', data.token)
          setToken(data.token)
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // user login 用户密码登录
  loginNew({ commit }, userInfo) {
    // const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      loginNew(userInfo)
        .then((response) => {
          const { data } = response
          console.log(data, 'seeee')
          commit('SET_TOKEN', data)
          setToken(data)
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  loginByWx({ commit }, userInfo) {
    // const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      loginByWx(userInfo)
        .then((response) => {
          const { data } = response
          console.log(data, 'seeee')
          commit('SET_TOKEN', data)
          setToken(data)
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  loginPhone({ commit }, userInfo) {
    // const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      loginPhone(userInfo)
        .then((response) => {
          const { data } = response
          commit('SET_TOKEN', data)
          setToken(data)
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // get user info
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getInfoNew()
        .then((response) => {
          const { data } = response
          if (!data) {
            reject('校验失败, 请重新登陆.')
            // reject('Verification failed, please Login again.')
          }
          let {
            account,
            name,
            unAuthProductList,
            authProductList,
            id,
            appImg,
            offlineProject,
            androidImg,
          } = data
          // roles must be a non-empty array
          // if (!roles || roles.length <= 0) {
          //   reject('getInfo: roles must be a non-null array!')
          // }
          if (!authProductList) {
            authProductList = []
          }
          if (!unAuthProductList) {
            unAuthProductList = []
          }
          console.log('process.env.VUE_DPA_HOST', process.env)
          authProductList.forEach((node) => {
            console.log('node', node)
            const btnInfo = JSON.parse(node.ButtonAuth)[0]
            node.icon = node.Logo.replace('logo', 'icon')
            node.projectCn = node.Name
            node.projectName = node.Name
            node.shortName = node.ShortName
            node.version = btnInfo.version
            node.clickGo = btnInfo.content
            node.button = btnInfo.icon
            if (node.Code === 'dpa') {
              node.Url = node.Url.replace(
                /https:\/\/[^/]+/,
                process.env.VUE_APP_DPA_HOST,
              )
            }
          })
          unAuthProductList.forEach((node) => {
            const btnInfo = JSON.parse(node.ButtonUnauth || '[]')
            const showInfo = btnInfo.find((item) => {
              return item.content == '产品介绍'
            }) || { url: '' }
            const otherInfo = btnInfo.find((item) => {
              return item.content !== '产品介绍'
            })
            console.log(showInfo)
            node.icon = node.Logo.replace('logo', 'icon')
            node.projectCn = node.Name
            node.shortName = node.ShortName
            node.version = 1
            node.viewDetailsUrl = showInfo.url || ''
            node.projectName = node.Code
            if (otherInfo) {
              node.clickGo = otherInfo.content
              node.button = otherInfo.icon || 'disable-button'
            } else {
              node.clickGo = showInfo.content
              node.button = 'detail-button'
            }
            // node.clickGo = btnInfo.content
          })
          // 2025-03-05 隐藏院系绩效和高校指标系统下线
          unAuthProductList = unAuthProductList.filter(
            (node) => !['hsid', 'PRES'].includes(node.Code),
          )
          // commit('SET_ROLES', roles)
          commit('SET_NAME', name)
          commit('SET_ACCOUNT', account)
          commit('SET_NOPAYPROJECT', unAuthProductList)
          commit('SET_YOURPROJECT', authProductList)
          commit('SET_ID', id)
          commit('SET_APPIMG', appImg)
          commit('SET_ANDROIDIMG', androidImg)
          commit('SET_OffLineProject', offlineProject)
          commit('SET_ISVOCATIONAL', data.isVocational)
          // commit('SET_AVATAR', avatar)
          // commit('SET_INTRODUCTION', introduction)
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // user logout  用户退出登录
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout({ token: getToken() })
        .then(() => {
          commit('SET_TOKEN', '')
          // commit('SET_ROLES', [])
          removeToken()
          // resetRouter()

          // reset visited views and cached views
          // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
          // dispatch('tagsView/delAllViews', null, { root: true })

          commit('SET_NOPAYPROJECT', [])
          commit('SET_YOURPROJECT', [])
          commit('SET_ISVOCATIONAL', null)
          commit('SET_ID', '')
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit('SET_TOKEN', '')
      // commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  // async changeRoles({ commit, dispatch }, role) {
  //   const token = role + '-token'

  //   commit('SET_TOKEN', token)
  //   setToken(token)

  //   const { roles } = await dispatch('getInfo')

  //   resetRouter()

  //   // generate accessible routes map based on roles
  //   const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })
  //   // dynamically add accessible routes
  //   router.addRoutes(accessRoutes)

  //   // reset visited views and cached views
  //   dispatch('tagsView/delAllViews', null, { root: true })
  // }
}

export default {
  state,
  mutations,
  actions,
}
